import usePrivateLink from "../../config/usePrivateLink";
import React, { useState } from "react";
import { Calendar } from "lucide-react";
import { Line } from "react-chartjs-2";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { StudentReciptDelete } from "../../../api/StudentServices";
import { ToastMain, SweetAlertShow } from "../../master/Master";

const TranctionTab = ({ data, getStudent }) => {
  const hasAccess = usePrivateLink();
  const student_id = data?.student;
  const transactions = data?.student?.transaction || [];
  const bank = data?.student;
  const emi = data?.student?.emi || [];
  const [loading, setLoading] = useState(false);
  // permissions for user role
const deleteRecipt = async (payload) => {
    setLoading(true);
    try {
      const response = await StudentReciptDelete(payload);
      // payload = { id, student_id, delete_reason }

      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: response?.data?.message || response?.message,
        }).then(() => {
          getStudent();
        });
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
   
    } finally {
      setLoading(false);
    }
  };

  // if (!transactions.length) {
  //   return (
  //     <div className="p-4 text-center text-muted">
  //       No transaction history available.
  //     </div>
  //   );
  // }

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <h5 className="mb-3">EMI Details</h5>
            <table className="table ">
              <thead className="table-primary text-center">
                <tr>
                  <th>Date</th>
                  <th>Amount (₹)</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {emi.length > 0 ? (
                  emi.map((item) => (
                    <tr key={item.id}>
                      <td>{item.emi_date}</td>
                      <td>₹{item.emi_amount}</td>
                      <td>
                        <span
                          className={`badge ${
                            item.emi_payment_status === "Due"
                              ? "bg-danger"
                              : "bg-success"
                          }`}
                        >
                          {item.emi_payment_status}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center text-muted">
                      No EMI Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="p-3 card mt-3">
        <div className="table-responsive">
          <table className="table text-nowrap align-middle">
            <thead className="table-label-primary">
              <tr>
                <th>#</th>
                <th>Fee Type</th>
                <th>Batch</th>
                <th>Date</th>
                <th>Bank </th>
                <th>Trans_id</th>
                <th>Action</th>

                <th className="text-end">Amount</th>
              </tr>
            </thead>
            <tbody>
              {transactions?.map((txn, index) => (
                <tr key={txn.id}>
                  <td>{index + 1}</td>
                  <td>
                    <span className="badge bg-primary">{txn?.fee_type}</span>
                  </td>
                  <td>{txn?.batch?.title || "N/A"}</td>
                  <td>
                    <span className="d-flex align-items-center text-muted small">
                      <Calendar size={14} className="me-1" />
                      {`${new Date(
                        txn.created_at
                      ).toLocaleDateString()} ${new Date(
                        txn.created_at
                      ).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}`}
                    </span>
                  </td>
                  <td>
                    <span className="badge bg-light text-dark">
                      {txn.bank?.account_no}
                      {txn.bank?.owner_name}
                    </span>
                  </td>
                  <td>{txn?.transaction_no || "N/A"}</td>
                  <td className="text-end fw-bold text-success">
                    ₹{txn.amount.toLocaleString()}
                  </td>
                  <td>
                    {hasAccess('/student/fees/receipt') && (
                      <button className="btn btn-sm btn-outline-primary">
                        <Link to={`/student/fees/receipt?id=${txn?.id}`}>
                          Print
                        </Link>{" "}
                      </button>
                    )}
                    {hasAccess('/student/fee/transaction/delete') && (
                      <button
                        className="btn btn-sm btn-outline-danger ms-2"
                        onClick={() =>
                          Swal.fire({
                            title: "Are you sure?",
                            text: "This action will permanently delete the Enquiry!",
                            icon: "warning",
                            input: "text",
                            inputPlaceholder: "Enter reason for deletion...",
                            showCancelButton: true,
                            confirmButtonColor: "#d33",
                            cancelButtonColor: "#6c757d",
                            confirmButtonText: "Yes, delete it!",
                            cancelButtonText: "Cancel",
                            preConfirm: (reason) => {
                              if (!reason) {
                                Swal.showValidationMessage(
                                  "Reason is required!"
                                );
                              }
                              return reason;
                            },
                          }).then(async (result) => {
                            if (result.isConfirmed) {
                              const payload = {
                                id: txn?.id, // ✅ first transaction id (75)
                                student_id: data?.student?.id, // ✅ student id (18)
                                delete_reason: result.value, // ✅ user entered reason
                              };

                              console.log("Delete Payload =>", payload);

                              deleteRecipt(payload);
                            }
                          })
                        }
                      >
                        <i className="bi bi-trash-fill mx-1 text-danger"></i>
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default TranctionTab;
